import BaseApi from "./BaseApi";

export default class Indirect extends BaseApi{
    construct() {}
    
 
    static async search(params) {
        return await Indirect.getAxiosInstance().get(Indirect.getFullApiUrl(),{params: params});
    }

    static async create(params) {
        return await Indirect.getAxiosInstance().post(Indirect.getFullApiUrl(),params);
    }

    static async find(id) {
        return await Indirect.getAxiosInstance().get(Indirect.getFullApiUrl() + id);
    }

    static async update(params, id) {
        return await Indirect.getAxiosInstance().put(Indirect.getFullApiUrl() + id,params);
    }

    static async delete(id) {
        return await Indirect.getAxiosInstance().delete(Indirect.getFullApiUrl() + id);
    }
    
    static async list(params) {
        let url = Indirect.getFullApiUrl() + "list";

        return Indirect.getAxiosInstance().get(url,{params: params});
    }
    
    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/indirect_work_hand/";
    }

    static getFullApiUrl(){
        let domain = location.pathname.split('/')[1]
        return BaseApi.getFullDomainApiUrl() + "api/" + domain + "/admin/indirect_work_hand/";
    }
}
